export default __webpack_public_path__ + "static/media/laundry1-afterA-2048w.33800755.png";